import { PaginationObj, SortingObj } from "../../components/investorOverview/types";

// action types
export const ALTERNATIVE_ASSET_ALLOCATION_SUCCESS = 'ALTERNATIVE_ASSET_ALLOCATION_SUCCESS';
export const ALTERNATIVE_ASSET_ALLOCATION_FAILURE = 'ALTERNATIVE_ASSET_ALLOCATION_FAILURE';

export const FUNDHOUSE_SUCCESS = 'FUNDHOUSE_SUCCESS';
export const FUNDHOUSE_FAILURE = 'FUNDHOUSE_FAILURE';

export const TOPFIVE_SUCCESS = 'TOPFIVE_SUCCESS';
export const TOPFIVE_FAILURE = 'TOPFIVE_FAILURE';


// component props type
export interface AlternativeAssetPieChartProps {
    completeData: AlternativeAssetAllocationRes
    isLoading: boolean
    clientCode: string,
    setFilterValue?: React.Dispatch<React.SetStateAction<number | string>>
}

export interface AlternativeAssetTableProps {
    completeData: AlternativeAssetAllocationRes
    isLoading: boolean
}

export interface FundHouseComponentProps {
    completeData: Array<FundHouseTable>
    isLoading: boolean
    onPageChange: (event: React.MouseEvent<HTMLButtonElement>, newPage: number) => void
    onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>, newRowsPerPage: number) => void
    sortingObj: SortingObj
    handletableSorting: (id: any, orderType: "asc" | "desc") => void
    totalPage: number
    paginationObj: PaginationObj

}

export interface AssetAllocationTableProps {
    tableBodyData: Array<AssetAllocationTable>
    isLoading: boolean
}


export interface TopFiveComponentProps {
    completeData: Array<topFiveTableObj>
    isLoading: boolean
    title: string
}

//api response and request type

export interface FundHouseApiRes {
    result: Array<FundHouseTable>
    message: string;
    isSuccess: boolean;
    totalLength: number

}

export interface TopFiveApiRes {
    result: {
        topSchemes: {
            data: Array<topFiveTableObj>
        };
        bottomSchemes: {
            data: Array<topFiveTableObj>;
        }
    }
    message: string;
    isSuccess: boolean;
}


export interface AlternativeAssetAllocationRes {
    result: {
        categoryWiseDistribution: {
            data: Array<Array<string>>;
            labelData: Array<{
                label: string;
                value: number;
            }>;
            totalValue: {
                label: string;
                value: number;
            };
        };
        categoryWiseBreakup: Array<AssetAllocationTable>;
    };
    message: string;
    isSuccess: boolean;
}

export interface AlternativeSchemeRes {
    result: Array<AlternateSchemeTableObj>;
    message: string;
    isSuccess: boolean;
    totalLength: number
}

export interface AlternateSchemeTableObj {
    schemeName: string
    investedValue: number
    marketValue: number
    exposure: number
    realGainLossPercentage: {
        amount: number
        percentage: number
    },
    inflow: number
    outflow: number
    percentage: {
        amount: number
        percentage: number
    },
    folioNo?: string
}

export interface FundHouseAllocationRes {
    result: Array<FundHouseTable>;
    message: string;
    isSuccess: boolean;
}

export interface AssetAllocationTable {
    categoryType: string;
    investedValue: number;
    marketValue: number;
    gainLoss: number;
    unRelease: number;
}
export interface FundHouseTable {
    fundHouseName: string;
    investedValue: number;
    marketValue: number;
    unRelGainLoss: number;
}

export interface topFiveTableObj {
    schemeName: string
    fundType: string
    fundHouse: string
    return: number
    exposure: number
    folioNo?: string
}